module.exports = __webpack_public_path__ + "img/banner02_it.2c2b3672.jpg";